import { createSelector } from 'reselect'
import { State } from 'interfaces/state'
import { isInternalOnboardingStepUrl } from 'helpers/pageHelpers'
import { getCurrentUrl } from 'helpers/utilsHelpers'

const onboardingStatusSelector = (state: State) => state.app.onboarding.status

export const isOnboardingFinishingSelector = createSelector(
  onboardingStatusSelector,
  (status) => {
    const isOnboarding = isInternalOnboardingStepUrl(getCurrentUrl())

    return isOnboarding && ['finishing', 'finished'].includes(status)
  }
)

export const isOnboardingClosedSelector = createSelector(
  onboardingStatusSelector,
  (status) => status === 'closed'
)

export const isOnboardingEndedSelector = createSelector(
  onboardingStatusSelector,
  (status) => ['finished', 'closed'].includes(status)
)
